<template>
    <div class="inline-block">
        <AttachItem
            v-for="option in options"
            :id="option.id"
            :key="option.text"
            :accept="option.accept"
            :color="option.color"
            :icon="option.icon"
            :text="option.text"
            :value="option.value"
        />
    </div>
</template>

<script lang="ts" setup>
import {
    CameraIcon,
    DocumentIcon,
    MapPinIcon,
    MicrophoneIcon,
    PhotoIcon,
    UserIcon,
    VideoCameraIcon
} from "@heroicons/vue/24/outline";
import {computed} from "vue";
import {Capacitor} from "@capacitor/core";
import {Attachment} from "@src/types";
import AttachItem from "@src/components/views/HomeView/MainArea/FooterArea/AttachSelector/AttachItem.vue";

const base: Attachment[] = [
    {
        id: 'attach-input-audio',
        icon: MicrophoneIcon,
        text: 'Áudio',
        color: 'bg-red-700 hover:bg-red-800',
        value: 'audio',
        accept: 'audio/AMR, audio/ogg, audio/mpeg'
    },
    {
        id: 'attach-input-video',
        icon: VideoCameraIcon,
        text: 'Vídeo',
        color: 'bg-orange-700 hover:bg-orange-800',
        value: 'video',
        accept: 'video/mp4'
    },
    {
        id: null,
        icon: MapPinIcon,
        text: 'Localização',
        color: 'bg-green-700 hover:bg-green-800',
        value: 'location',
        accept: null
    },
    {
        id: null,
        icon: UserIcon,
        text: 'Contato',
        color: 'bg-yellow-700 hover:bg-yellow-800',
        value: 'contact',
        accept: null
    },
    {
        id: 'attach-input-document',
        icon: DocumentIcon,
        text: 'Documento',
        color: 'bg-blue-700 hover:bg-blue-800',
        value: 'document',
        accept: '*/*'
    },
    {
        id: 'attach-input-image',
        icon: PhotoIcon,
        text: 'Imagem',
        color: 'bg-purple-700 hover:bg-purple-800',
        value: 'image',
        accept: 'image/png, image/jpeg'
    }
]

const options = computed<Attachment[]>(() => {
    if (!Capacitor.isNativePlatform()) return base
    return [
        {
            id: null,
            icon: CameraIcon,
            text: 'Câmera',
            color: 'bg-teal-700 hover:bg-teal-800',
            value: 'camera',
            accept: null,
        },
        ...base,
    ]
})
</script>

<style scoped>
</style>